import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const DruhDluhuSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Spotreb. úver',
      value: 'Spotreb. úver',
    },
    {
      label: 'Pôžička',
      value: 'Pôžička',
    },
    {
      label: 'Kred. karta',
      value: 'Kred. karta',
    },
    {
      label: 'Hypotéka',
      value: 'Hypotéka',
    },
    {
      label: 'Autoúver',
      value: 'Autoúver',
    },
    {
      label: 'Kontokorent',
      value: 'Kontokorent',
    },
    {
      label: 'Povol. debet',
      value: 'Povol. debet',
    },
    {
      label: 'Nepovol. debet',
      value: 'Nepovol. debet',
    },
    {
      label: 'Úver',
      value: 'Úver',
    },
    {
      label: 'Soc. Poisťovňa',
      value: 'Soc. Poisťovňa',
    },
    {
      label: 'Zdrav. poisťovňa',
      value: 'Zdrav. poisťovňa',
    },
    {
      label: 'Finančná správa',
      value: 'Finančná správa',
    },
    {
      label: 'Iný',
      value: 'Iný',
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default DruhDluhuSelect;
